export const getHostname = (): string => window.location.hostname;

export const getCookieDomain = (): string => {
  if (process.env.NODE_ENV === "development") {
    return window.location.hostname;
  }

  const [, ...parentDomainChunks] = getHostname().split(".");

  return `.${parentDomainChunks.join(".")}`;
};
